/* this file is transformed by vux-loader */

/* eslint-disable */
import base from '../base';
import http from '../http';
var Agent = {
  insert: function insert(params) {
    return http.put("".concat(base.dev, "/edAgentDevicePrice/insert"), params);
  },
  updateByPrimaryKey: function updateByPrimaryKey(params) {
    return http.post("".concat(base.dev, "/edAgentDevicePrice/updateByPrimaryKey"), params);
  },
  selectListPageByEntity: function selectListPageByEntity(params) {
    return http.post("".concat(base.dev, "/edAgentDevicePrice/selectListPageByEntity"), params);
  },
  selectListByEntity: function selectListByEntity(params) {
    return http.post("".concat(base.dev, "/edAgentDevicePrice/selectListByEntity"), params);
  },
  deleteByPrimaryKey: function deleteByPrimaryKey(id) {
    return http.delete("".concat(base.dev, "/edAgentDevicePrice/deleteByPrimaryKey"), {
      params: {
        id: id
      }
    });
  },
  selectByPrimaryKey: function selectByPrimaryKey(id) {
    return http.get("".concat(base.dev, "/edAgentDevicePrice/selectByPrimaryKey"), {
      params: {
        id: id
      }
    });
  }
};
export default Agent;